<template>
  <div>
    <!-- 资金/入金名义维护 -->
    <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.depositNominalMaintenance')"></baseBreadcrumb>
    <div class="body">
      <!-- 搜索 -->
      <div class="search">

        <div class="item">
          <el-input v-model="datas.realname" :placeholder="$t('message.userName')" clearable></el-input>
        </div>
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.userID')" clearable></el-input>
        </div>
        <!-- 入金名义模糊搜索 -->
        <div class="item">
          <el-input v-model="datas.pay_account" :placeholder="$t('message.depositNominalFuzzySearch')"
            clearable></el-input>
        </div>
        <div class="item">
          <el-button type="primary" @click="search">{{ $t('message.filter') }}</el-button>
          <!-- 重置 -->
          <el-button @click="reset">{{ $t('message.reset') }}</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <!-- 客户ID -->
          <li>{{ $t('message.userID') }}</li>
          <!-- 客户登录名 -->
          <li>{{ $t('message.customerLoginName') }}</li>
          <!-- 客户名称 -->
          <li>{{ $t('message.userName') }}</li>
          <!-- 银行 -->
          <li>{{ $t('message.bank') }}</li>
          <!-- 当前默认名义 -->
          <li>{{ $t('message.currentDefaultName') }}</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <div class="content" v-for="(item, index) in list" :key="index">
          <div class="item">{{ item.id }}</div>
          <div class="item">{{ item.username }}</div>
          <div class="item">{{ item.realname }}</div>
          <div class="list">
            <ul v-for="(items, indexs) in item.user_pay_account" :key="indexs">
              <!-- 银行 -->
              <li>{{ items.bill_method_name }}</li>
              <!-- 当前默认名义 -->
              <li>{{ items.default.pay_account }}</li>
              <!-- 名义设置 -->
              <li>
                <el-button type="primary" @click="nominalSetting(items, item)">{{ $t('message.nominalSetting')
                }}</el-button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 入金名义设置 -->
    <el-dialog :title="$t('message.nominalSetting')" :visible.sync="dialogVisible" width="820px" center
      :close-on-click-modal="false">
      <div class="dialog">
        <!-- 列表 -->
        <div class="list" v-for="(item, index) in clientPayAccount.list" :key="index">
          <div class="input">
            <el-input v-model="item.pay_account" type="textarea" :placeholder="$t('message.mingYi')"></el-input>
          </div>
          <div class="item">
            {{ item.created_at }}
          </div>
          <div class="item">
            <!-- 设为默认 -->
            <el-button type="primary" size="mini" v-if="!item.is_default" @click="defaultItem(index)">{{
              $t('message.setAsDefault') }}</el-button>
            <!--  -->
            <el-button type="text" v-else>{{ $t('message.currentDefault') }}</el-button>
          </div>
          <div class="item">
            <el-button type="primary" class="dark" size="mini" @click="del(index)">{{ $t('message.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="add">
        <el-button type="success" size="mini" @click="add">{{ $t('message.add') }}</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="setClientPayAccount">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {
        user_id: '',
        realname: '',
        page: 1,
        pageSize: 20,
      },
      total: 0,
      list: [],
      dialogVisible: false,
      // 名义
      clientPayAccount: {
        list: [],
        user_id: '',
        bill_method: '',
      },

    };
  },
  created() {
    this.clientPayAccountList()
  },
  methods: {
    // 筛选
    search() {
      this.datas.page = 1
      this.clientPayAccountList()
    },
    //重置
    reset() {
      this.datas = {
        user_id: '',
        realname: '',
        page: 1,
        pageSize: 20,
        pay_account: '',
      }
      this.clientPayAccountList()
    },
    clientPayAccountList() {
      this.$api.financialApi.clientPayAccountList(this.datas).then(res => {
        // 查找是否有当前默认名义
        res.data.data.forEach(item => {
          item.user_pay_account.forEach(items => {
            let defaultItem = items.list.find(itemss => itemss.is_default == 1)
            if (defaultItem) {
              items.default = defaultItem
            } else {
              items.default = {}
            }
          })
        })
        this.list = res.data.data
        this.total = res.data.total

      })
    },
    // 客户-详情-设置客户入金名义
    setClientPayAccount() {
      this.$api.financialApi.setClientPayAccount(this.clientPayAccount).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.clientPayAccountList()
      })
    },
    // 名义设置
    nominalSetting(items, item) {
      this.clientPayAccount = JSON.parse(JSON.stringify(items))
      this.clientPayAccount.user_id = item.id
      this.dialogVisible = true
    },
    //新增
    add() {
      this.clientPayAccount.list.push({
        is_default: 0,
        pay_account: '',
      })
    },
    // 删除
    del(i) {
      this.clientPayAccount.list.splice(i, 1)
    },
    //设为默认
    defaultItem(i) {
      this.clientPayAccount.list.forEach(item => {
        item.is_default = 0
      })
      this.clientPayAccount.list[i].is_default = 1
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.clientPayAccountList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.clientPayAccountList();
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 48px;
  }
}

.table {
  margin: 24px 0;

  ol {
    border: 1px solid #ccc;
    position: sticky;
    top: 0;
    left: 0
  }

  li {
    border-right: 1px solid #ccc;

    &:nth-last-child(1) {
      border: 0;
    }
  }

  .content {
    display: flex;
    border: 1px solid #ccc;
    border-top: 0;

    ul {
      padding: 0;
      border-bottom: 1px solid #ccc;

      &:nth-last-child(1) {
        border: 0;
      }

      li {
        padding: 10px 0;
      }
    }

    .item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #ccc;
    }

    .list {
      flex: 3;
    }
  }
}

.dialog {
  margin-bottom: 20px;
  max-height: 500px;
  overflow-y: auto;

  .list {
    display: flex;
    border: 1px solid #ccc;
    border-top: 0;

    &:nth-child(1) {
      border-top: 1px solid #ccc;
    }

    .input {
      flex: 2;
      padding: 10px;
    }

    .item {
      padding: 10px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid #ccc;
    }
  }
}
</style>